"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractOutputRefsCodec = exports.contractOutputRefCodec = void 0;
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
const array_codec_1 = require("./array-codec");
const codec_1 = require("./codec");
const int_as_4bytes_codec_1 = require("./int-as-4bytes-codec");
exports.contractOutputRefCodec = new codec_1.ObjectCodec({
    hint: int_as_4bytes_codec_1.intAs4BytesCodec,
    key: codec_1.byte32Codec
});
exports.contractOutputRefsCodec = new array_codec_1.ArrayCodec(exports.contractOutputRefCodec);
